import preparedReducer from './reducer';
import * as allSelectors from './selectors';
import {
  requestRoutes,
  requestRouteDetail,
  createRoute,
  updateRoute,
  copyRoute,
  suspendRoute,
  resumeRoute,
  deleteRoute,
  requestRouteRuns,
  requestRouteRunDetail,
  requestAllRuns,
  requestRunById,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'mobileRoutes';

export const selectors = (state) => state[SLICE_NAME];

export const {
  selectMobileRoutes,
  selectList,
  selectListRows,
  selectSelected,
  selectSelectedRun,
  selectRunHistory,
  selectRunsList,
  selectRunsListRows,
  selectError,
  selectLoading,
} = allSelectors;

export const actions = {
  requestRoutes,
  requestRouteDetail,
  createRoute,
  updateRoute,
  copyRoute,
  suspendRoute,
  resumeRoute,
  deleteRoute,
  requestRouteRuns,
  requestRouteRunDetail,
  requestAllRuns,
  requestRunById,
};
